/*
    generate by magix-combine@3.6.4: https://github.com/thx/magix-combine
    author: kooboy_li@163.com
    loader: webpack
 */

Magix.applyStyle("xf2b","@font-face{font-family:sem_icf;src:url(//at.alicdn.com/t/font_1436352478_7451568.eot);src:url(//at.alicdn.com/t/font_1436352478_7451568.eot#iefix) format(\"embedded-opentype\"),url(//at.alicdn.com/t/font_1436352478_7451568.woff) format(\"woff\"),url(//at.alicdn.com/t/font_1436352478_7451568.ttf) format(\"truetype\"),url(//at.alicdn.com/t/font_1436352478_7451568.svg#iconfont) format(\"svg\")}.option_filter{background:#fff;border:1px solid #e8e8e8;color:#747474}.option_filter a{color:#333}.option_filter a:hover{text-decoration:none;color:#ef470f}.option_filter .from,.option_filter .others,.option_filter .price_area{float:left;padding:0 20px;border-right:1px solid #e8e8e8;cursor:pointer;line-height:38px}.option_filter .from.on,.option_filter .others.on,.option_filter .price_area.on{background:#f5f5f5}.option_filter .default{border-left:1px solid #e8e8e8}.option_filter .price_area{padding:0 10px;border:none}.option_filter .price_area .shadow{line-height:38px}.option_filter .price_area .shadow input{width:42px;padding:1px 1px 1px 3px;height:20px;border:1px solid #ccc;color:#777}.option_filter .price_area .shadow span{padding:0 2px;color:#777}.option_filter .price_area .shadow .confirm{display:none}.option_filter .price_area.out .shadow{position:relative;margin-left:-10px;margin-right:-70px;padding-left:10px;width:220px;-webkit-box-shadow:1px 1px 6px #aaa;box-shadow:1px 1px 6px #aaa;background:#fff;z-index:10}.option_filter .price_area.out .shadow .confirm{display:inline-block;margin-left:12px;padding:0 10px;line-height:24px;border-radius:3px;background:#ff4200;color:#fff}.option_filter .from{padding:0 10px 0 5px;height:38px;border-right:none;position:relative}.option_filter .from .trigger{display:block;margin-top:7px;padding-left:4px;height:22px;line-height:22px;border:1px solid #ccc}.option_filter .from .trigger span{float:left}.option_filter .from .trigger i{float:right;margin-left:4px;padding:0 2px;border-left:1px solid #ccc;background:#f5f5f5;font-style:normal;font-family:sem_icf}.option_filter .from .trigger i:after{content:\"\\e601\"}.option_filter .from .content{position:absolute;margin-top:-1px;padding:0 10px;width:340px;line-height:24px;border:1px solid #ccc;background-color:#fff;display:none}.option_filter .from:hover .content{display:block}.option_filter .from .content li{padding:5px 0;border-top:1px dashed #ccc}.option_filter .from .content li a{display:inline-block;margin:0 2px;padding:0 7px;border-radius:4px}.option_filter .from .content li a.on{background:#ff4200;color:#fff}.option_filter .from .content .first{border-top:none}.option_filter .from .content .first .same_city{display:none;margin-left:10px}.option_filter .others{float:right;padding:0 10px;border:none;border-left:1px solid #e8e8e8}.option_filter .others .tag_option{float:left;position:relative;margin:0 1px 0 18px}.page-tmall .option_filter .from .content li a.on,.page-tmall .option_filter .price_area.out .shadow .confirm{background:#c40000}");

module.exports = Magix.View.extend({
    tmpl: {"html":"<div class=\"option_filter clearfix\"><div class=\"filter_area\"><div class=\"price_area\"><div class=\"shadow\">价格： <input mx-guid=\"g0\u001f\" id=\"priceRange_0\" class=\"rmb\" placeholder=\"¥\" value=\"<%= $$.root.url.minPrice%>\"><span>-</span><input mx-guid=\"g1\u001f\" id=\"priceRange_1\" class=\"rmb\" placeholder=\"¥\" value=\"<%= $$.root.url.maxPrice%>\"><a class=\"confirm\" href=\"#\" data-spm-click=\"gostr=/alimama.231.7755927;locaid=dsortpricerange\">确定</a></div></div><div class=\"from cpnt_menu J_filter_citys\" data-spm=\"076265160012\"><span class=\"trigger\"><span id=\"from_value\">发货地</span><i></i></span></div><div class=\"others\"><a class=\"tag_option type_ship\" href=\"#\" data-spm-click=\"gostr=/alimama.231.7755927;locaid=dtype_ship\"><input mx-guid=\"g2\u001f\" id=\"status_ship\" type=\"checkbox\" name=\"ship\" <%if($$.root.url.ship==\"1\"){%> checked=\"checked\" <%}%>> 包邮</a><a class=\"tag_option type_itemAssurance\" href=\"#\" data-spm-click=\"gostr=/alimama.231.7755927;locaid=dtype_itemAssurance\"><input mx-guid=\"g3\u001f\" id=\"status_itemAssurance\" type=\"checkbox\" name=\"itemAssurance\" <%if($$.root.url.itemAssurance==\"1\"){%> checked=\"checked\" <%}%>> 正品保障</a><a class=\"tag_option type_exchange7\" href=\"#\" data-spm-click=\"gostr=/alimama.231.7755927;locaid=dtype_exchange7\"><input mx-guid=\"g4\u001f\" id=\"status_exchange7\" type=\"checkbox\" name=\"exchange7\" <%if($$.root.url.exchange7==\"1\"){%> checked=\"checked\" <%}%>> 7天退换</a><a class=\"tag_option type_custAssurance\" href=\"#\" data-spm-click=\"gostr=/alimama.231.7755927;locaid=dtype_custAssurance\"><input mx-guid=\"g5\u001f\" id=\"status_custAssurance\" type=\"checkbox\" name=\"custAssurance\" <%if($$.root.url.custAssurance==\"1\"){%> checked=\"checked\" <%}%>> 消费者保障</a></div></div></div>","subs":[{"keys":["root"],"path":"input[mx-guid=\"g0\u001f\"]","attr":"value=\"<%= $$.root.url.minPrice%>\"","attrs":[{"n":"value","q":1,"p":1}]},{"keys":["root"],"path":"input[mx-guid=\"g1\u001f\"]","attr":"value=\"<%= $$.root.url.maxPrice%>\"","attrs":[{"n":"value","q":1,"p":1}]},{"keys":["root"],"path":"input[mx-guid=\"g2\u001f\"]","attr":"<%if($$.root.url.ship==\"1\"){%> checked=\"checked\" <%}%>","attrs":[{"n":"checked","b":1,"p":1}]},{"keys":["root"],"path":"input[mx-guid=\"g3\u001f\"]","attr":"<%if($$.root.url.itemAssurance==\"1\"){%> checked=\"checked\" <%}%>","attrs":[{"n":"checked","b":1,"p":1}]},{"keys":["root"],"path":"input[mx-guid=\"g4\u001f\"]","attr":"<%if($$.root.url.exchange7==\"1\"){%> checked=\"checked\" <%}%>","attrs":[{"n":"checked","b":1,"p":1}]},{"keys":["root"],"path":"input[mx-guid=\"g5\u001f\"]","attr":"<%if($$.root.url.custAssurance==\"1\"){%> checked=\"checked\" <%}%>","attrs":[{"n":"checked","b":1,"p":1}]}]},
    city: "<ol class=\"list content\"><li class=\"first\"><a href=\"#\" id=\"city_\">不限</a></li>{{#each citys}}<li>{{#each this}}<a href=\"#\" id=\"city_{{../../xindex}}_{{xindex}}\">{{this}}</a>{{/each}}</li>{{/each}}</ol>",
    ctor: function ctor(opt) {
        this.opt = $.extend(true, opt, {
            S: KISSY,
            Brick: null,
            XTemplate: null,
            Uri: null
        });
    },
    initOptionFilter: function initOptionFilter() {
        var S = this.opt.S,
            Brick = this.opt.Brick,
            XTemplate = this.opt.XTemplate,
            Uri = this.opt.Uri;

        var AREALIST = [['北京', '上海', '广州', '深圳', '杭州', '海外', '江浙沪', '京津冀', '港澳台'], ['长沙', '长春', '成都', '重庆', '大连', '东莞', '佛山', '福州', '贵阳', '合肥', '金华', '济南', '嘉兴', '昆明', '宁波', '南昌', '南京', '青岛', '泉州', '沈阳', '苏州', '天津', '温州', '无锡', '武汉', '西安', '厦门', '郑州', '中山', '石家庄', '哈尔滨'], ['安徽', '福建', '甘肃', '广东', '广西', '贵州', '海南', '河北', '河南', '湖北', '湖南', '江苏', '江西', '吉林', '辽宁', '宁夏', '青海', '山东', '山西', '陕西', '云南', '四川', '西藏', '新疆', '浙江', '澳门', '香港', '台湾', '内蒙古', '黑龙江']];

        var AreaTemplate = this.city; //S.one("#J_template_city") && S.one("#J_template_city").html()

        var queryString = location.search.length > 0 ? location.search.substring(1) : "";
        var queryArgs = S.unparam(queryString);

        var SelectLoc = null;
        if (queryArgs.loc) {
            S.each(AREALIST, function (items, index) {
                if (S.indexOf(queryArgs.loc, items) > -1) {
                    SelectLoc = index + "_" + S.indexOf(queryArgs.loc, items);
                }
            });
        }

        var C_URL = window.location.href;
        var OptionFilter = {
            bindUI: function bindUI() {
                // this.set("el", )
                S.one(".J_filter_citys").append(new XTemplate(AreaTemplate).render({
                    citys: AREALIST
                }));
                if (SelectLoc) {
                    S.one("#city_" + SelectLoc).addClass("on");
                    S.one("#from_value").html(queryArgs.loc.replace(/[<>]/ig, ""));
                }
            },
            bindEvent: function bindEvent() {
                S.one('.filter_area').on('click', OptionFilter.click_filter_area);
                S.one('.price_area').on('keyup', OptionFilter.keyup_price_area).on('focusin', OptionFilter.focusin_price_area);

                S.one(window).on('click', OptionFilter.click_window);
            },
            click_filter_area: function click_filter_area(e) {
                var target = S.one(e.target),
                    url;

                if (target[0].tagName == 'INPUT') {
                    target = target.parent();
                    target._from_input = true;
                }

                if (target[0].tagName != 'A') {
                    return;
                }

                url = target.attr('data-url');

                if (url === undefined) {

                    if (target[0].id.match(/^city_/) != null) {
                        url = new Uri(C_URL);
                        url.query.remove("spm");
                        if (target.html() == "不限") {
                            url.query.remove('loc');
                        } else {
                            url.query.set('loc', target.html());
                        }
                        url = url.toString();
                    } else if (target.hasClass('tag_option')) {
                        url = new Uri(C_URL);
                        if (target._from_input) {
                            //发生在input上
                            if (target.children('input').attr('checked') != 'checked') {
                                url.query.remove(target.children('input').attr('name'));
                            } else {
                                url.query.set(target.children('input').attr('name'), 1);
                            }
                        } else {
                            //发生在a上
                            if (target.children('input').attr('checked') != 'checked') {
                                url.query.set(target.children('input').attr('name'), 1);
                            } else {
                                url.query.remove(target.children('input').attr('name'));
                            }
                        }
                        url = url.toString();
                    } else if (target.hasClass('confirm')) {
                        url = new Uri(C_URL);
                        var input = target.parent().all('input'),
                            v1 = input[0].value,
                            v2 = input[1].value,
                            price = {},
                            priceStr;

                        //都有值的时候，大小位置无关，可以互换顺序
                        if (v1 && v2) {
                            price = {
                                min: Math.min(v1, v2),
                                max: Math.max(v1, v2)
                            };
                        } else {
                            price = {
                                min: v1,
                                max: v2
                            };
                        }

                        input[0].value = price.min;
                        input[1].value = price.max;
                        url.query.remove('minPrice');
                        url.query.remove('maxPrice');
                        if (price.min) {
                            url.query.set('minPrice', price.min);
                        }
                        if (price.max) {
                            url.query.set('maxPrice', price.max);
                        }
                    }
                }
                if (url == '') {
                    return;
                } else {
                    url = new Uri(url);
                    // 去其他参数
                    url.query.remove("page");
                }

                // url.query.set('prepvid', window.pvid);
                // url.query.set('spm', self.getFullSpm(target));
                if (target[0].tagName == "A" && target.attr("data-spm-anchor-id")) {
                    // 支持spm
                    url.query.set("spm", target.attr("data-spm-anchor-id"));
                }

                location.href = url.toString();
            },
            keyup_price_area: function keyup_price_area(e) {
                var target = S.all(e.target),
                    val = S.trim(target.val()),
                    dot = val.match(/\./g);

                if (e.target.tagName != 'INPUT') {
                    return;
                }

                //替换非数字字符
                val = val.replace(/[^0-9.]/g, '');

                //多余2个小数点,保留一个小数
                if (dot && dot.length > 1) {
                    val = val.match(/^[0-9]*\.[0-9]*/g)[0];
                }

                //保留两个小数点
                val = val.replace(/(\.\d\d)\d+/, "$1");

                target.val(val);
            },
            focusin_price_area: function focusin_price_area(e) {
                if (!S.one('.price_area').hasClass('out')) {
                    S.one('.price_area').addClass('out');
                }
            },

            click_window: function click_window(e) {
                var target = S.one(e.target);
                if (!target.parent('.price_area')) {
                    S.one('.price_area').removeClass('out');
                }
            }
        };

        OptionFilter.bindUI();
        OptionFilter.bindEvent();
    },

    render: function render() {
        var self = this;
        KISSY.use("xtemplate, uri", function (S, XTemplate, Uri) {
            self.opt.XTemplate = XTemplate;
            self.opt.Uri = Uri;
            self.updater.set({
                root: window.root || { url: {} }
            }).digest();
            self.initOptionFilter();
        });
    }
});


//////////////////
// WEBPACK FOOTER
// ./app/views/optionfilter/index.js
// module id = 5
// module chunks = 1 2